"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observe = void 0;
var utils_1 = require("../utils");
var QueueCallFun_1 = require("./QueueCallFun");
var Observe = /** @class */ (function () {
    function Observe() {
        this.listener = {};
    }
    /**
     * 监听事件
     * @param eventName - 事件名称
     * @param callback - 事件处理回调函数
     * @returns 销毁事件
     */
    Observe.prototype.on = function (eventName, callback) {
        var _this = this;
        var evtId = "Observe_evt_" + utils_1.utils.guid();
        if (typeof callback !== "function") {
            throw new Error("事件监听回调参数不是Function。");
        }
        if (!this.listener[eventName]) {
            this.listener[eventName] = {
                eventIds: [],
                handlers: {}
            };
        }
        this.listener[eventName].handlers[evtId] = callback;
        this.listener[eventName].eventIds.push(evtId);
        return function () {
            var evtIndex = _this.listener[eventName].eventIds.indexOf(evtId);
            _this.listener[eventName].eventIds.splice(evtIndex, 1);
            delete _this.listener[eventName].handlers[evtId];
            if (_this.listener[eventName].eventIds.length <= 0) {
                delete _this.listener[eventName];
            }
        };
    };
    /**
     * 解除事件绑定， 如果eventName为空时默认删除所有事件
     * @param eventName - 要删除的事件名称
     */
    Observe.prototype.unBind = function (eventName) {
        if (!utils_1.utils.isEmpty(eventName)) {
            delete this.listener[eventName];
        }
        else {
            this.listener = {};
        }
    };
    /**
     * 触发事件监听
     * @param eventName - 事件名称
     * @param args - 传递参数
     * @returns
     */
    Observe.prototype.emit = function (eventName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            if (_this.listener[eventName]) {
                var eventIds = _this.listener[eventName].eventIds || [];
                QueueCallFun_1.queueCallFunc(__spreadArray(__spreadArray([], eventIds), [{
                        id: "LastResult",
                        params: "",
                        // tslint:disable-next-line: object-literal-sort-keys
                        fn: function (opt) {
                            return opt.lastResult;
                        }
                    }]), function (opt, eventId) {
                    var callback = _this.listener[eventName].handlers[eventId];
                    return callback.apply(void 0, args);
                }, {
                    throwException: true,
                    // tslint:disable-next-line: object-literal-sort-keys
                    paramConvert: function (evtId) {
                        if (typeof evtId === "string") {
                            return {
                                id: evtId,
                                params: evtId
                            };
                        }
                        else {
                            return evtId;
                        }
                    }
                }).then(function (data) { return resolve(data.LastResult); })
                    .catch(reject);
            }
            else {
                resolve(null);
            }
        });
    };
    return Observe;
}());
exports.Observe = Observe;
